import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AdminLayout from './components/AdminLayout';
import Home from './pages/Home';
import Doctors from './pages/Doctors';
import DoctorDetail from './pages/DoctorDetail';
import Departments from './pages/Departments';
import DepartmentDetail from './pages/DepartmentDetail';
import BookAppointment from './pages/BookAppointment';
import MyAppointments from './pages/MyAppointments';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import Contact from './pages/Contact';
import About from './pages/About';
import Services from './pages/Services';
import PrivateRoute from './components/PrivateRoute';

// Admin Pages
import AdminDashboard from './pages/Admin/Dashboard';
import AdminAppointments from './pages/Admin/Appointments';
import AdminSliders from './pages/Admin/Sliders';
import AdminCategories from './pages/Admin/Categories';
import AdminServices from './pages/Admin/Services';
import AdminUsers from './pages/Admin/Users';

import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="doctors" element={<Doctors />} />
        <Route path="doctors/:id" element={<DoctorDetail />} />
        <Route path="departments" element={<Departments />} />
        <Route path="departments/:id" element={<DepartmentDetail />} />
        <Route path="services" element={<Services />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        
        {/* Protected Routes */}
        <Route path="book-appointment" element={
          <PrivateRoute>
            <BookAppointment />
          </PrivateRoute>
        } />
        <Route path="my-appointments" element={
          <PrivateRoute>
            <MyAppointments />
          </PrivateRoute>
        } />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin/dashboard" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminDashboard />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/appointments" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminAppointments />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/sliders" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminSliders />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/categories" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminCategories />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/services" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminServices />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/users" element={
        <PrivateRoute>
          <AdminLayout>
            <AdminUsers />
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/events" element={
        <PrivateRoute>
          <AdminLayout>
            <div className="container mt-4"><h2>Events Management</h2><p>Coming Soon</p></div>
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/gallery" element={
        <PrivateRoute>
          <AdminLayout>
            <div className="container mt-4"><h2>Gallery Management</h2><p>Coming Soon</p></div>
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/coupons" element={
        <PrivateRoute>
          <AdminLayout>
            <div className="container mt-4"><h2>Coupons Management</h2><p>Coming Soon</p></div>
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/testimonials" element={
        <PrivateRoute>
          <AdminLayout>
            <div className="container mt-4"><h2>Testimonials Management</h2><p>Coming Soon</p></div>
          </AdminLayout>
        </PrivateRoute>
      } />
      <Route path="/admin/company" element={
        <PrivateRoute>
          <AdminLayout>
            <div className="container mt-4"><h2>Company Profile</h2><p>Coming Soon</p></div>
          </AdminLayout>
        </PrivateRoute>
      } />
    </Routes>
  );
}

export default App;
